import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'
import { CommonTable } from 'gnos-tables'
import _ from 'lodash'

import { LOCALE_PREFIX } from '../../../../constants'

import { reduceProvider } from './helpers'
import { TABLE_DATA_FORMAT } from './constants'

import './style.scss'

@injectIntl
export default class SubTable extends Component {
    static propTypes = {
        data: PropTypes.object,
        intl: PropTypes.object,
    }

    getColumnsDefinition = (data) => {
        const { intl } = this.props

        return [
            {
                accessor: 'firstCol',
                Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.provider` }),
                width: 130,
                Cell: (value) => <span>{`${value.value}`}</span>,
            },
            ..._.reduce(
                data,
                (result, provider) => [
                    ...result,
                    {
                        accessor: `${_.get(provider, 'providerId', null)}`,
                        Header: _.get(provider, 'name') || ' ',
                    },
                ],
                []
            ),
        ]
    }

    prepareData = (data) => {
        const { intl } = this.props

        return {
            _table: _.map(TABLE_DATA_FORMAT, (valueFormat) => ({
                firstCol: intl.formatMessage({ id: `${LOCALE_PREFIX}.${_.get(valueFormat, 'captionSelector')}` }),
                ...reduceProvider(data, valueFormat.valueSelector, intl, valueFormat.type),
            })),
        }
    }

    render() {
        const { data } = this.props

        const tableData = this.prepareData(_.get(data, 'providers', []))

        return (
            <div className={'sub-component-container'}>
                <div className={'info-container'}>
                    <div className={'info-row'}>
                        <span className={'info-row-caption'}>
                            <FormattedMessage id={`${LOCALE_PREFIX}.wholeProjectName`} />
                        </span>
                        <span>{_.get(data, 'projectName', '')}</span>
                    </div>
                    <div className={'info-row'}>
                        <span className={'info-row-caption'}>
                            <FormattedMessage id={`${LOCALE_PREFIX}.schema`} />
                        </span>
                        <span>{_.get(data, 'programName', '')}</span>
                    </div>
                </div>
                <div className={'sub-table-container'}>
                    <CommonTable
                        id={'grants-sub-component-table'}
                        columnsDefinition={this.getColumnsDefinition(_.get(data, 'providers', []))}
                        staticData={tableData}
                    />
                </div>
            </div>
        )
    }
}
